<template>
  <div>
    <v-expansion-panel-header ripple @click="gerarRelatorioOperador(operador)">
      {{ operador.dadosOperador.text }}
      <template v-slot:actions>
        <v-icon color="orangePcm">$expand</v-icon>
      </template>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-sheet v-show="showSkeleton" class="pa-3">
        <v-skeleton-loader class="mx-auto" type="table" />
      </v-sheet>

      <TableInterna :dadosRelatorioOperador="dataOperador" :form="form" v-show="!showSkeleton" />
    </v-expansion-panel-content>
  </div>
</template>

<script>
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'

import { registerVuexModule } from '@/utils/vuexUtils'

import relatorioDetalhadoOperadorStore from '../_store'
import relatorioDetalhadoOperadorUtil from '../_utils/relatorioDetalhadoOperadorUtil'

import TableInterna from './TableInterna'

export default {
  name: 'ExpandListExterno',
  components: { TableInterna },
  props: {
    operador: Object,
    form: Object,
  },

  data: () => ({
    moment: moment,
    dataOperador: [],
    showSkeleton: false,
  }),

  computed: {
    ...mapGetters('relatorioOperadorDetalhadoStore', ['getDadosRelatorioOperadorIndividual']),
  },

  async created() {
    registerVuexModule(this.$store, 'relatorioOperadorDetalhadoStore', relatorioDetalhadoOperadorStore)
  },

  methods: {
    ...mapActions('relatorioOperadorDetalhadoStore', ['gerarRelatorioOperadorIndividual']),

    ...relatorioDetalhadoOperadorUtil,
    async gerarRelatorioOperador(operador) {
      if (operador.podeGerar) {
        this.showSkeleton = true

        await this.gerarRelatorioOperadorIndividual({ form: this.form, idOperador: operador.dadosOperador.value })

        this.dataOperador = this.getDadosRelatorioOperadorIndividual.map(dadoRelatorio => ({
          dataHora: moment(dadoRelatorio.dateStartCall, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss'),
          origem: dadoRelatorio.numeroOrigem,
          destino: this.verificaDestino(dadoRelatorio),
          centroDeCusto: this.verificaCentroDeCusto(dadoRelatorio),
          centroDeCustoTooltip: this.verificaCentroDeCustoTooltip(dadoRelatorio),
          tipo: this.verificaTipoChamada(dadoRelatorio.tipoChamada),
          tipoTooltip: this.verificaTipoChamadaTooltip(dadoRelatorio.tipoChamada),
          fila: this.verificaFila(dadoRelatorio),
          status: dadoRelatorio.status
            ? this.verificaStatusChamada(dadoRelatorio.status)
            : this.verificaStatusChamada(dadoRelatorio.tipo),
          linkedId: dadoRelatorio.record,
          record: dadoRelatorio.linkAudio,
          linkAudio: dadoRelatorio.linkAudio,
          tipoChamada: dadoRelatorio.tipoChamada,
        }))

        this.showSkeleton = false
        operador.podeGerar = false
      }
    },
  },
}
</script>
